export const boden = '#5a5a5a';
export const black = '#000000';
export const mora = '#ff3334';
export const skara = '#75AE3C';
export const white = '#ffffff';
